import Avatar from '@atlaskit/avatar/Avatar';
import { getDatabaseContainerType } from '@databases/analytics';
import type { AddFlagProps } from '@databases/flags-types';
import React from 'react';

import { type ContentTypesFlagProps } from '@canvas/frame-api-types';

import { BaseMentionBuilder } from './baseMentionBuilder';
import { messages } from './i18n';
import { type MentionBuilder } from './types';

export class MentionFlagForSingleUser
  extends BaseMentionBuilder
  implements MentionBuilder
{
  shouldShowFlag(): boolean {
    return this.usersWithAccess.length === 1;
  }
  build(): AddFlagProps & ContentTypesFlagProps {
    const { displayName, profilePicture } = this.usersWithAccess[0];
    const actions = [
      {
        content: this.formatMessage(
          messages['mention-notification.flag-go-to-field-settings-cta']
        ),
        onClick: () => {
          this.showPanel('FieldSettingsPanel', { fieldId: this.fieldId });

          this.analyticsClient.sendMentionNotificationActionEvent({
            contentId: this.contentId,
            databaseContainer: getDatabaseContainerType()
          });
        }
      }
    ];

    return {
      id: `mention-flag-for-single-user-${this.contentId}`,
      type: 'custom',
      iconString: 'avatar',
      profilePicture,
      title: this.formatMessage(
        messages['mention-notification.flag-mention-notification-title-one-user'],
        { displayName }
      ),
      description: !this.isLocked
        ? this.formatMessage(
            messages['mention-notification.flag-mention-notification-description']
          )
        : this.formatMessage(
            messages[
              'mention-notification.flag-mention-notification-description-without-field-settings'
            ]
          ),
      icon: () => <Avatar src={profilePicture} label="" />,
      actions: !this.isLocked ? actions : undefined
    };
  }
}
